const IMAGE_BASE_URL = "https://rishabhgold.com/storage/"
export default IMAGE_BASE_URL
